module.exports = __webpack_public_path__ + "static/media/login-background.c5b246d1.png";